import React from "react";
import { Modal } from "react-bootstrap";

export default function ImageViewModal({ size = "xl", imageSrc, setImgModalOpen, isImgModalOpen, zoomInOut, handleZoomInOut }) {

    return (
        <React.Fragment>
            <Modal show={isImgModalOpen} size={size} onHide={setImgModalOpen} centered scrollable>
                <Modal.Body>
                    <div className="overflow-auto">
                        <img src={imageSrc} alt={`displaying-image`} style={{ width: '100%', maxHeight: '500px', objectFit: "fill", cursor: zoomInOut ? "zoom-out" : "zoom-in", transform: zoomInOut ? "scale(2)" : "", transformOrigin: "top left", }} onClick={handleZoomInOut} />
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}